// import getUserMedia from "../getUserMedia.ts";
  import api from "../api";
  import axios from "axios";
//   import DetailedResults from "./DetailedResults.vue";
  // import PrintReport from "./PrintReport.vue";
//   import GeneralPlan from "./GeneralPicture.vue";
//   import CollectionType from "./CollectionType.vue";
  import csrftoken from "../getToken";
  import moment from "../../node_modules/moment/src/moment.js";
//   import DiagnoseRecord from "./DiagnoseRecord.vue";
  import "swiper/dist/css/swiper.css";
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import {mapState, mapMutations, mapGetters} from "vuex";
//   import Tree from "./Tree.vue";
  // import addDiagnosisGql from '../gql/addDiagnosis.gql'
  // 民族json对象
  import raceJson from "../race.js";
  import gql from "graphql-tag";
  import Util from "../utils/utils.js";
  import _ from "lodash";
  import {clearUnderMirror} from "../utils/clearUnderMirror.js";
  import {checkImage} from "../utils/imageAuto.js";
  import {lookPhoto} from "../utils/lookPhoto.js";
//   import {printReport} from "../utils/printReport.js";
//   import CompareImage from './CompareImage';
  let template = {};
  
  let that;
  
  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    // differentContent.errorCon = '请先进行智能搜图!!';
    differentContent.errorCon = '请先进行以图搜图!!';
  } else {
    differentContent.errorCon = '请先进行以图搜图!!';
  }
  
  export default {
    beforeCreate() {
      that = this;
    },
    data() {
      const checkIdInHospital = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
          /*clearTimeout(this.timer);
          this.timer = setTimeout(async () => {
            if (this.useID) {
              callback();
            } else {
              if (!this.fromNewDiagnose) {
                if (!this.found) {
                  
                  const obj = await this.patientIdRepeat(value);
                  // 如果找到患者就将患者信息填入
                  if (obj.id) {
                    callback('');
                    this.$message.error('ID已存在');
                    /!*this.useID = true;
                    this.isReset = true;
                    this.readonly = true;
                    this.fromNewDiagnose = true;
                    const birthday = moment(obj.birthday).format("YYYY-M-D");
                    this.form.id = obj.id;
                    this.form.id_in_hospital = obj.id_in_hospital;
                    this.form.name = obj.name;
                    this.form.birthday = birthday;
                    this.form.skin_color = obj.skin_color;
                    this.form.gender = obj.gender;
                    this.form.phone = obj.phone;
                    this.form.race = obj.race;
                    this.form.address = obj.address;
                    this.form.idCardNumber = obj.id_card_number;
                    this.form.nativePlace = obj.native_place;
                    this.form.country = obj.country;
                    this.form.profession = obj.profession;
                    this.form.email = obj.email;
                    this.patient_id = obj.id;
                    // 请求历史诊断列表
                    this.getHistoryCheckData();*!/
                  } else {
                    callback();
                  }
                  callback();
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }, 300);*/
        }
      };
      const checkFee = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
          if (reg.test(value)) {
            callback();
          } else {
            this.$message.error("请输入合法的费用!!");
            callback("");
          }
        }
      };
      // 检查生日
      const checkBirthday = (rule, value, callback) => {
        let reg = /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/;
        if (value === "") {
          callback("");
        } else {
          if (reg.test(value)) {
            callback();
          } else {
            callback("");
          }
        }
      };
      // 检查用户名
      const checkName = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      // 校验电话号码
      const checkPhone = (rule, value, callback) => {
        let reg = /^1\d{10}/;
        if (reg.test(value)) {
          callback();
        } else {
          callback("");
        }
      };
      const checkSkin = (rule, value, callback) => {
        if (value) {
          callback("");
        } else {
          callback();
        }
      };
      const checkApplyDoctor = (rule, value, callback) => {
        if (typeof value !== "string") {
          callback("");
        } else {
          if (value === "") {
            callback("");
          } else {
            callback();
          }
        }
      };
      const checkUnit = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      const checkDiagnoseNum = async (rule, value, callback) => {
        if (value === "") {
          callback("");
        }
      };
      const checkcheckId = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      const checkEmail = (rule, value, callback) => {
        let reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
        if (value === "") {
          callback();
        }
        if (reg.test(value)) {
          callback();
        } else {
          this.form.email = "";
          callback("");
        }
      };
      
      return {
        differentContent,
        imageSrcPrefix: api.imageSrcPrefix,
        // 是否已选择id
        useID: false,
        // 验证id的定时器
        // 新建患者成功后状态改变
        found: false,
        timer: null,
        newDownLoad: false,
        // 显示特定的诊断
        showSepPort: false,
        currentDiagnose: {},
        showLargeImage: false,
        largeImage: "",
        textAreaMaxLen: 512,
        // 是否显示input框验证状态
        isShowStateIcon: true,
        // 新建患者重新渲染该组件
        newP: true,
        // 其他描述
        otherDescription: "",
        allReport: [],
        // 皮肤镜报告对象
        skinReportObj: {},
        // 大体图报告对象
        genralReportObj: {},
        // ct报告对象
        ctReportObj: {},
        // bc报告对象
        bcReportObj: {},
        // 病理报告对象
        blReportObj: {},
        figureObj: raceJson.position.man,
        // 是否收藏
        isCollection: false,
        // 将要被删除的部位
        willDeletePosition: "",
        // 是否显示诊断记录
        showDiagnoseRecord: false,
        // 诊断结果
        diagnoseResult: "",
        // 医生建议
        advise: "",
        // 百科筛选字段
        filterText: "",
        defaultProps: {
          children: "children",
          label: "name"
        },
        // 选中表格的id
        choosedTableId: 0,
        // 是否显示检查部位的一级菜单
        checkoverview: false,
        // 申请医生的列表
        applyDoctors: [],
        // 是否存在申请医生的列表
        applyDoctorsExist: false,
        patientMore: true,
        checkMore: true,
        NoShow: false,
        isTakePhone: false,
        // 申请单位
        applyUnitData: raceJson.applyUint,
        // 疾病预览结果
        overview_result: [],
        compareImgObj: {},
        // 删除部位的索引
        deletePositionIndex: 0,
        compareDialog: false,
        // 民族的可选项
        // 显示智能搜图弹框
        showIntelligentSearch: false,
        races: raceJson.raceObj,
        fileList: [],
        value: "",
        value2: "",
        currentImg: "",
        dialogVisible: false,
        currentIndex: -1,
        currentIndex2: -1,
        imgList: [],
        imgList2: [],
        imgList3: [],
        // 显示报告
        showPort: false,
        // 报告图片数组
        /**
         * {
         *    "ct": [{id: "",path:""},{id: "",path: ""}],
         *    "bc": [{id: "",path:""},{id: "",path: ""}],
         *    "general": [{id: "",path:""},{id: "",path: ""}],
         *    "skin": [{id: "",path:""},{id: "",path: ""}],
         *    "bl": [{id: "",path:""},{id: "",path: ""}],
         * }
         */
        reportImgs: [],
        test: "",
        activeName2: "first",
        mediaStreamTrack: null,
        index: "",
        patient_id: "",
        star: "el-icon-star-off",
        tagged: 0,
        file: "",
        report: "",
        resiltsVisible: false,
        loading: false,
        disabled: false,
        wordbook: null,
        resultData: {},
        isHid: false,
        detail_result: [],
        isCorrect: false,
        doctor_conclusion: "",
        viewResults: 0,
        response_time: "",
        checkedIndex: [],
        report_images: [],
        // 控制tag变化的内容
        isGeneral: true,
        isCT: false,
        isBC: false,
        skin: false,
        bl: false,
        tagObj: {},
        form: {
          id: "",
          // 患者id
          id_in_hospital: "",
          // 姓名
          name: "",
          birthday: "",
          age: '',
          skin_color: "",
          skin_type: "",
          gender: "男",
          phone: "",
          // 民族
          race: "",
          // 地址
          address: "",
          // 身份证号
          idCardNumber: "",
          // 籍贯
          nativePlace: "",
          country: "",
          // 职业
          profession: "",
          email: "",
          created_time: '',
        },
        // 可选标签
        tags: [
          {
            text: "大体图/伍德灯",
            checked: true,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "皮肤镜",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "CT",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "B超",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          },
          {
            text: "病理",
            checked: false,
            activecolor: "#eff3f7",
            color: "#61a2bf"
          }
        ],
        // 校验患者信息的规则
        patientRules: {
          id_in_hospital: {
            required: false,
            validator: checkIdInHospital,
            trigger: "blur"
          },
          
          name: {required: false, validator: checkName, trigger: "blur"},
        },
        checkRules: {
          // applicant: {
          //   required: false,
          //   validator: checkApplyDoctor,
          //   trigger: "change"
          // },
          // applicant_unit: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "change"
          // },
          // unit: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "change"
          // },
          // id_in_hospital: {
          //   required: false,
          //   validator: checkDiagnoseNum,
          //   trigger: "blur"
          // },
          // initial_conclusion: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "blur"
          // },
          // review_doctor: {
          //   required: false,
          //   validator: checkUnit,
          //   trigger: "change"
          // },
          
          // fee: {required: false, validator: checkFee, trigger: "change"},
          // checkId: {required: false, validator: checkcheckId, trigger: "blur"}
        },
        form2: {
          // 申请医生
          applicant: "",
          applicant_unit: "",
          review_doctor: "",
          // 单位
          unit: "",
          // 临床诊断
          initial_conclusion: "",
          // 检查编号
          id_in_hospital: "",
          // 检查费用
          fee: "",
          // patient_id患者id
          // 检查部位
          position_overview_list: "",
          // 具体位置
          position_detail_list: "",
          // 主诉
          complaint: "",
          // 病史
          disease_history_before: "",
          // 现病史
          disease_history_present: "",
          // 家族史
          disease_history_family: "",
          // 实验室
          lab: ""
        },
        skinOps: raceJson.skinOpn,
        skinOpsType:raceJson.skinOpnType,
        options: Object.keys(raceJson.position.man),
        options2: null,
        tableData: [],
        diagnosisId: -1,
        restaurants: [],
        isReset: false,
        readonly: false,
        isResult: false,
        currentType: "",
        showBigList: false,
        swiperOption: {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          pagination: {
            el: ".myswiper-pagination",
            clickable: true
          }
        },
        // mirrorType: [Util.GENERAL.code, Util.SOAK.code, Util.POLARRIZE.code, Util.CT.code, Util.BC.code ,Util.PATHOLOGY.code],
        centerDialogVisible: false,
        deleteImgIndex: "",
        deleteImgId: "",
        editImgId: "",
        fromNewDiagnose: false,
        fromDetailDiagnose: false,
        // 当前编辑的第几张图片
        currentEditorIndex: 0,
        // 一级菜单所悬浮的当前索引
        topLevelIndex: 0,
        // 二级菜单所悬浮的当前索引
        secondLevelIndex: 0,
        // 选择的位置的数组
        choosedPosition: [],
        // 移动到已选择部位的索引
        choosedPositionIndex: 0,
        // 删除该部位提示
        deletePositionDialog: false,
        knowledgeData: [],
        // 诊断记录
        diagnosesRecordList: [],
        // 历史检查记录id数组
        historyDiagnoseIds: [],
        // 是否是新的诊断
        isNewDiagnose: false,
        // 申请单位
        applyUnit: [],
        // 审核医生
        review_doctor_cache: [],
        // 检查单位
        check_unit: [],
        // 是否禁用智能搜图
        disableIntell: false,
        // 生成报告时候的报告对象
        reportObj: {},
        // 病的id
        diseaseId: -1,
        // 所有病的名字
        allDisease: [],
        reloadCollection: true,
        overviewList: [],
        detailList: [],
        // 费用列表
        feeList: [],
        // tree类型
        diagnoseType: "",
        hospital_id_disabled: false,
        patient_id_disabled: false,
        
        knowledgeDic: {},
        template: {},
        diseaseid: "",
        treeReload: true,
        selectedDiagnose: false,
        diagnose_id_in_hospital: "",
        scrollChange: false,
        isShowMenu: false,
        // 控制是否填上检查信息
        isHandleExamineInfo: false,
        // 防止blur事件和selectedDisease重复触发的状态
        isTrigger: false,
        // 点击编辑跳转过来时传入模板中的镜下所见数据
        reportText: {},
        // 选择的相机
        selectCamera: '',
        // 相机列表
        CameraList: [],
        picType: '',
        // 皮肤镜类型
        SkinType: [
          {
            value: '2',
            label: '浸润',
          },
          {
            value: '4',
            label: '偏振光',
          },
        ],
        // 选择拍摄皮肤镜类型
        selectSkinType: '4',
        initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
        tracks: [],
        isProcessing: false,
      };
    },
    mixins: [clearUnderMirror, lookPhoto],
    async mounted() {
      // await this.queryMyTemplate();
      let res1 = await axios.request({
        method: "get",
        url: api.wordbook,
        headers: {
          "x-csrf-token": csrftoken
        },
        withCredentials: true
      });
      this.wordbook = res1.data;
      // 存进localStorage
      if (!!localStorage.getItem("applyUnit")) {
        this.applyUnit = JSON.parse(localStorage.getItem("applyUnit"));
      }
      if (!!localStorage.getItem("reviewDoctorCache")) {
        this.review_doctor_cache = JSON.parse(
          localStorage.getItem("reviewDoctorCache")
        );
      }
      if (!!localStorage.getItem("checkUnit")) {
        this.check_unit = JSON.parse(localStorage.getItem("checkUnit"));
      }
      if (!!localStorage.getItem("applyDoctors")) {
        this.applyDoctorsExist = true;
        this.applyDoctors = JSON.parse(localStorage.getItem("applyDoctors"));
      } else {
        this.applyDoctorsExist = false;
      }
      if (!!localStorage.getItem("fee")) {
        this.feeList = JSON.parse(localStorage.getItem("fee"));
      }
      // 从诊断详情点击编辑跳转回来相关处理
      if (this.$store.state.modifyDiagnosisData.isModify) {
        // 如果是点击编辑跳转过来就执行
        await this.handleModifyDiagnosisData();
      }
      if (this.isHandleExamineInfo) {
        this.handleExamineInfo()
      }
      let params = this.$router.currentRoute.params;
      switch (params.from) {
        case "patientListNewDialoges":
          break;
        case "diagnoseDetial":
          this.patient_id = params.pId;
          this.getHistoryCheckData();
          this.diagnosisId = params.dId;
          
          break;
      }
      const myDate = (function getNowFormatDate() {
        const date = new Date();
        const seperator1 = "-";
        const seperator2 = ":";
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        const currentdate =
          date.getFullYear() +
          seperator1 +
          month +
          seperator1 +
          strDate +
          " " +
          date.getHours() +
          seperator2 +
          date.getMinutes() +
          seperator2 +
          date.getSeconds();
        return currentdate;
      })();
      let self = this;
      this.$nextTick(() => {
        self.video = self.$refs.video;
        self.canvas = self.$refs.imgCanvas;
        self.img = self.$refs.img;
      });
      // 请求皮肤镜报告模板数据
      axios
        .request({
          method: "get",
          url: api.knowledge
        })
        .then(res => {
          this.knowledgeData = res.data.children;
        });
      this.isHandleExamineInfo = false;
      if (window.localStorage.getItem('skinType')) {
        this.selectSkinType = window.localStorage.getItem('skinType');
      }
      /*if (!this.readonly) {
        if (this.$refs.idInput) {
          this.$refs.idInput.focus();
        }
      }*/
    },
    computed: {
      ...mapGetters(["getReportImgs", "getPToIntell"]),
      // 选中的部位
      activePosition() {
        let activedPosition;
        for (let i = 0; i < this.choosedPosition.length; i++) {
          if (this.choosedPosition[i].active) {
            activedPosition = this.choosedPosition[i];
          }
        }
        return activedPosition;
      },
      // 当前所选择标签下的图片数组
      currentTagImages() {
        let backArr = [];
        if (this.isGeneral) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.GENERAL.code) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.isCT) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.CT.code) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.isBC) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.BC.code) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.skin) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (
              this.imgList[i].type === Util.SOAK.code ||
              this.imgList[i].type === Util.POLARRIZE.code
            ) {
              backArr.push(this.imgList[i]);
            }
          }
        } else if (this.bl) {
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i].type === Util.PATHOLOGY.code) {
              backArr.push(this.imgList[i]);
            }
          }
        }
        return backArr;
      }
    },
    // 监听属性值变化
    watch: {
      compareDialog(newval) {
        if (!newval) {
          this.compareImgObj = {};
        }
      },
      getPToIntell: {
        handler(newval, oldval) {
          if (!!this.$store.state.pToIntellParams) {
            this.$store.state.chooseItImgArr = [];
            let params = this.$store.state.pToIntellParams;
            this.form.id = params.id;
            this.form.created_time = params.created_time;
            this.form.id_in_hospital = params.id_in_hospital;
            this.form.birthday = params.birthday === moment(this.initialTime).format('YYYY-MM-DD') ? '' : params.birthday;
            this.form.age = params.age > -1 ? (params.age + '') : '';
            this.form.id_card_number = params.id_card_number;
            this.form.phone = params.phone;
            this.form.profession = params.profession;
            this.form.gender = params.gender;
            this.form.name = params.name;
            this.form.race = params.race;
            this.form.skin_color = params.skin_color;
            this.form.skin_type = params.skin_type;
            this.form.address = params.address;
            this.form.idCardNumber = params.id_card_number;
            this.form.nativePlace = params.native_place;
            this.form.country = params.country;
            this.form.email = params.email;
            this.patient_id = params.id;
            this.$store.commit("setoperationPatientId", params.id);
            this.getHistoryCheckData();
            this.readonly = true;
            this.isNewDiagnose = true;
            this.fromNewDiagnose = true;
            this.$store.commit("clearPToIntell");
            this.isHandleExamineInfo = true
          }
          // 开启新的诊断
        },
        immediate: true,
        deep: true
      }
    },
    async created() {
      /*this.$root.$on('connect2server', () => {
        if (sessionStorage.getItem("username")) {
          if (window.eventSrc) {
            window.eventSrc.close();
          }
          window.eventSrc = new EventSource(api.event, {
            withCredentials: true
          });
          window.eventSrc.onmessage = async event => {
            this.$root.$emit(event.data);
          };
          window.eventSrc.onopen = () => {
            window.lastHeartBeat = new Date();
          };
        
          window.eventSrc.addEventListener("hb", event => {
            window.lastHeartBeat = new Date();
          });
        }
      });*/
      //Ai搜图事件返回结果
    /*  window.eventSrc.addEventListener("ai_diagnosis_result", event => {
        const response = JSON.parse(event.data);
        that.overview_result = response.detail_result;
        that.detail_result = response.detail_result;
        that.loading = false;
        that.resultData = response;
        // 解禁按钮
        that.disableIntell = false;
        that.isHid = true;
        that.isResult = true;
        that.$message({
          message: "成功",
          type: "success"
        });
        
      });*/
      if (!sessionStorage.getItem("username")) {
        // 获取检查医生
        this.$router.push({path: "/login"});
      }
      /*this.$root.$on("refresh-diagnosis-images", async () => {
        if (this.diagnosisId && this.diagnosisId !== -1) {
          await this.loadImages();
        }
      });*/
      // 获取报告模板病名与id文件
      try {
        const knowledgeDic = await axios.request({
          method: "get",
          url: api.knowledgeDic
        });
        this.knowledgeDic = knowledgeDic.data;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    beforeDestroy() {
      // this.$root.$off("refresh-diagnosis-images");
      this.clearPortData();
    },
    methods: {
      // 根据影像诊断id查找影像诊断病名
      filterConclusion(id) {
        let name;
        // 从自定义模板中找病种名称
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              name = data[i].name;
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (template.myTemplate) {
          f(template.myTemplate);
        }
        // 如果自定义中没有找到则在原始模板中查找
        if (!name) {
          if (that.wordbook) {
            if (that.wordbook[id]) {
              name = that.wordbook[id].name
            }
          }
        }
        return name ? name : ''
      },
      // 获取医生自定义模板
      async queryMyTemplate() {
        debugger
        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          return;
        }
        const msg =  await axios.request({
          method: 'get',
          url: api.template + path,
        });
        template = msg.data;
      },
      // 通过id找自定义模板中对应的对象
      queryMyTemplateById(id) {
        let obj;
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              obj = data[i];
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        return obj;
      },
      // 通过name找自定义模板中对应对象
      queryMyTemplateByName(name) {
        let obj;
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].name === name) {
              obj = data[i];
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        return obj;
      },
      async getCreatedTime(id) {
        const res = await this.$apollo.query({
          query: gql`{
            patient(id:${id}){
              id
              created_time
            }
          }`,
          fetchPolicy: "no-cache"
        });
        this.form.created_time = moment(res.data.created_time).format('YYYY-MM-DD');
      },
      keydownTakePicture(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.keyCode === 123 || e.keyCode === 32) {
          this.takePicture();
        }
      },
      // 选择了拍摄设备
      cameraChange() {
        this.showCamera();
      },
      // 获取摄像头列表
      async getCameraList() {
        if (navigator.mediaDevices || navigator.mediaDevices.enumerateDevices) {
          const enumeratorPromise = await navigator.mediaDevices.enumerateDevices();
          const deviceArr = enumeratorPromise.filter(item => item.kind === 'videoinput');
          if (deviceArr.length > 0) {
            let count = 1;
            this.CameraList = deviceArr.map(item => {
              return {
                value: item.deviceId,
                label: item.label || `Camera ${count++}`,
              }
            });
            // 选中上次拍摄的设备，如果没有记忆上次拍摄的设备就默认选中第一个
            if (window.localStorage.getItem('selectCamera')) {
              const cameraId = window.localStorage.getItem('selectCamera');
              const filterDevice = deviceArr.filter(item => item.deviceId === cameraId);
              if (filterDevice.length > 0) {
                this.selectCamera = cameraId;
              } else {
                this.selectCamera = deviceArr[0].deviceId;
              }
            } else {
              this.selectCamera = deviceArr[0].deviceId;
            }
          } else {
            this.CameraList = [];
            this.selectCamera = '';
          }
        }
      },
      // 显示拍摄影像
      async showCamera() {
        try {
          if (this.selectCamera) {
            const videoConstraints = {};
            videoConstraints.deviceId = {exact: this.selectCamera};
            const constraints = {
              video: videoConstraints,
              audio: false
            };
            navigator.mediaDevices
              .getUserMedia(constraints)
              .then(stream => {
                try {
                  this.video.srcObject = stream;
                } catch (e) {
                  this.video.src = window.URL.createObjectURL(stream);
                }
                self.video.play();
                this.tracks = stream.getTracks();
              })
              .catch(error => {
                this.$message.error(error.message);
              });
          } else {
            // this.video.load();
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 诊断详情页点击编辑跳转过来，把信息填上
      async handleModifyDiagnosisData() {
        // 将患者信息填上
        const patientinfo = this.$store.state.modifyDiagnosisData.patientinfo;
        this.form.id = patientinfo.id;
        this.form.created_time = moment(patientinfo.created_time).format('YYYY-MM-DD');
        this.form.id_in_hospital = patientinfo.id_in_hospital;
        this.form.birthday = patientinfo.birthday === moment(this.initialTime).format('YYYY-MM-DD') ? '' : patientinfo.birthday;
        this.form.age = patientinfo.age > -1 ? (patientinfo.age + '') : '';
        this.form.id_card_number = patientinfo.id_card_number;
        this.form.phone = patientinfo.phone;
        this.form.profession = patientinfo.profession;
        this.form.gender = patientinfo.gender;
        this.form.name = patientinfo.name;
        this.form.race = patientinfo.race;
        this.form.skin_color = patientinfo.skin_color;
        this.form.skin_type = patientinfo.skin_type;
        this.form.address = patientinfo.address;
        this.form.idCardNumber = patientinfo.id_card_number;
        this.form.nativePlace = patientinfo.native_place;
        this.form.country = patientinfo.country;
        this.form.email = patientinfo.email;
        this.patient_id = patientinfo.id;
        this.getHistoryCheckData();
        this.readonly = true;
        // this.isNewDiagnose = true;
        this.fromNewDiagnose = true;
        // 将诊断信息填上
        const diagnosisinfo = this.$store.state.modifyDiagnosisData.diagnosisinfo;
        this.form2.applicant = diagnosisinfo.applicant;
        this.form2.applicant_unit = diagnosisinfo.applicant_unit;
        this.form2.review_doctor = diagnosisinfo.review_doctor;
        this.form2.unit = diagnosisinfo.unit;
        this.form2.fee = diagnosisinfo.fee ? String(diagnosisinfo.fee / 100) : '';
        this.form2.initial_conclusion = diagnosisinfo.initial_conclusion;
        this.form2.complaint = diagnosisinfo.complaint;
        this.form2.disease_history_before = diagnosisinfo.disease_history_before;
        this.form2.disease_history_present = diagnosisinfo.disease_history_present;
        this.form2.lab = diagnosisinfo.lab;
        this.form2.disease_history_family = diagnosisinfo.disease_history_family;
        this.diagnose_id_in_hospital = diagnosisinfo.id_in_hospital;
        this.diagnosisId = diagnosisinfo.id;
        this.form2.position_overview_list = diagnosisinfo.position_overview_list;
        this.form2.position_detail_list = diagnosisinfo.position_detail_list;
        this.isCollection = diagnosisinfo.tagged;
        if (diagnosisinfo.position_detail_list) {
          const detailPositionArr = diagnosisinfo.position_detail_list.split(',');
          const choosedPosition = detailPositionArr.map(item => {
            return {
              active: false,
              detailPosition: item.split('-')[1],
              overviewPosition: item.split('-')[0],
            }
          });
          this.choosedPositionIndex = choosedPosition.length - 1;
          choosedPosition[choosedPosition.length - 1].active = true;
          this.choosedPosition = choosedPosition;
        }
        if (diagnosisinfo.doctor_conclusion) {
          this.diagnoseResult = this.filterConclusion(diagnosisinfo.doctor_conclusion);
        }
        this.advise = diagnosisinfo.doctor_suggestion;
        // 将镜下所见数据传入
        this.reportText = {
          b_ultrasonic_report_text: diagnosisinfo.b_ultrasonic_report_text,
          ct_report_text: diagnosisinfo.ct_report_text,
          dermoscopy_report_text: diagnosisinfo.dermoscopy_report_text,
          pathology_report_text: diagnosisinfo.pathology_report_text,
          macro_report_text: diagnosisinfo.macro_report_text,
        }
        // 显示图片
        this.refreshImages();
        this.$store.commit('clearModifyDiagnosisId');
      },
      // 将最新一次填写的检查信息填上
      handleExamineInfo() {
        if (this.applyDoctors.length > 0) {
          this.$set(this.form2, 'applicant', this.applyDoctors[this.applyDoctors.length - 1].value);
        }
        if (this.applyUnit.length > 0) {
          this.$set(this.form2, 'applicant_unit', this.applyUnit[this.applyUnit.length - 1].value);
        }
        if (this.review_doctor_cache.length > 0) {
          this.$set(this.form2, 'review_doctor', this.review_doctor_cache[this.review_doctor_cache.length - 1].value)
        }
        if (this.check_unit.length > 0) {
          this.$set(this.form2, 'unit', this.check_unit[this.check_unit.length - 1].value)
        }
        if (this.feeList.length > 0) {
          this.$set(this.form2, 'fee', this.feeList[this.feeList.length - 1].value)
        }
      },
      refreshImages() {
        // this.$root.$emit("refresh-diagnosis-images")
      },
      showMenu(bool) {
        this.isShowMenu = bool;
      },
      scrollLog(e) {
        if (this.isShowMenu) {
          this.scrollChange = !this.scrollChange;
          this.isShowMenu = false;
        }
      },
      async takePicture() {
        if (!this.isProcessing) { // 防止连续触发
          this.isProcessing = true;
          if (this.picType === 'dt') {
            await this.takePhotos(Util.GENERAL.code);
            this.isProcessing = false;
          } else if (this.picType === 'sk') {
            await this.takePhotos(Number(this.selectSkinType));
            this.isProcessing = false;
            window.localStorage.setItem('skinType', this.selectSkinType);
          }
        }
      },
      // 验证id是否重复（新）
      async verifyIdRepeat() {
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $id_in_hospital: String!
            ){
              getByIdInHospital(
                id_in_hospital: $id_in_hospital
              ){
                id
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              id_in_hospital: this.form.id_in_hospital,
            },
          });
          if (res.data.getByIdInHospital.length) {
            this.$message.error('患者ID被占用，请核实后重新填写相关信息');
          } else {
            return true;
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 根据id和姓名匹配用户
      async verificationPatient() {
        if (this.form.id_in_hospital && this.form.name) {
          try {
            const res = await this.$apollo.query({
              query: gql`query(
                $id_in_hospital: String!
                $patient_name: String!
              ){
                isAccessPatient(
                  id_in_hospital: $id_in_hospital
                  patient_name: $patient_name
                ){
                  id
                  id_in_hospital
                  name
                  birthday
                  age
                  skin_color
                  skin_type
                  gender
                  phone
                  race
                  address
                  id_card_number
                  native_place
                  country
                  profession
                  email
                  created_time
                }
              }`,
              fetchPolicy: "no-cache",
              variables: {
                id_in_hospital: this.form.id_in_hospital,
                patient_name: this.form.name,
              },
            });
            if (res.data.isAccessPatient.length) {
              const data = res.data.isAccessPatient[0];
              const dataForm = {
                id: data.id,
                // 患者id
                id_in_hospital: data.id_in_hospital,
                // 姓名
                name: data.name,
                birthday: data.birthday === this.initialTime ? '' : moment(data.birthday).format('YYYY-MM-DD'),
                age: data.age > -1 ? (data.age + '') : '',
                skin_color: data.skin_color,
                skin_type: data.skin_type,
                gender: data.gender,
                phone: data.phone,
                // 民族
                race: data.race,
                // 地址
                address: data.address,
                // 身份证号
                idCardNumber: data.id_card_number,
                // 籍贯
                nativePlace: data.native_place,
                country: data.country,
                // 职业
                profession: data.profession,
                email: data.email,
                created_time: data.created_time,
              };
              this.useID = true;
              this.isReset = true;
              this.readonly = true;
              this.fromNewDiagnose = true;
              this.form = dataForm;
              this.patient_id = data.id;
              // 将最近一次填写检查信息填写上
              this.handleExamineInfo();
              // 请求历史诊断列表
              this.getHistoryCheckData();
              // 重置form表单验证状态
              this.$refs.form.resetFields();
              this.$message({
                type: "success",
                message: "患者已登记，请继续填写病历信息",
              });
            } else {
              return await this.verifyIdRepeat();
            }
          } catch (error) {
            console.log(error)
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      // form
      patientForm() {
        setTimeout(async () => {
          const newval = this.form;
          if (!this.fromNewDiagnose) {
            if (this.patient_id !== "") {
              // 修改患者信息
              await this.modifySicker(newval);
            } else {
              // 进行匹配和查重
              const result = await this.verificationPatient();
              if (result) {
                if (
                  newval.id_in_hospital !== "" &&
                  newval.name !== "" &&
                  newval.gender !== "" &&
                  (newval.birthday || newval.age !== '')
                ) {
                  const obj = await this.patientIdRepeat(this.form.id_in_hospital);
                  if (!obj.id) {
                    let addRes = await this.addSicker(newval);
                    this.patient_id = addRes.data.addPatient.id;
                    this.form.id = addRes.data.addPatient.id;
                    this.getCreatedTime(addRes.data.addPatient.id);
                    this.$message({
                      type: "success",
                      message: "添加患者成功"
                    });
                    this.found = true;
                    this.patient_id_disabled = true;
                    // 将最近一次填写检查信息填写上
                    this.handleExamineInfo()
                    // 如果此时诊断信息填写完毕就进行诊断信息的提交
                    if (
                      this.form2.position_overview_list !== "" &&
                      this.form2.position_detail_list !== ""
                    ) {
                      await this.addDiagnosis();
                    }
                  }
                }
              }
            }
          }
          if (newval.gender === "女") {
            this.position = Object.keys(raceJson.position.woman);
            this.figureObj = raceJson.position.woman;
          } else {
            this.position = Object.keys(raceJson.position.man);
            this.figureObj = raceJson.position.man;
          }
        }, 300);
      },
      // 保存top5
      async saveTop5({data, isSaveBtn}) {
        let parentId = "";
        if (data.dis === true) {
          const top5Knowledge = this.template.top5Knowledge[this.diagnoseType];
          // 取父级id
          if (data.predefine === true) {
            parentId = data.id;
          } else {
            parentId = data.id.replace(/-\d+$/, "").replace(/^\w+-/, "");
          }
          const filterArr = top5Knowledge.filter(item => {
            return item.id === parentId;
          });
          if (filterArr.length > 0) {
            const obj = top5Knowledge[top5Knowledge.indexOf(filterArr[0])];
            if (obj.children.length >= 5) {
              obj.children.splice(4, 1);
            }
            // 判断是否已存在
            const filters = obj.children.filter(item => {
              return item.name === data.name;
            });
            if (filters.length > 0) {
              const index = obj.children.indexOf(filters[0]);
              obj.children.splice(index, 1);
            }
            obj.children.unshift(data);
          } else {
            top5Knowledge.push({
              id: parentId,
              children: [data]
            });
          }
        }
        // 镜下所见点击保存按钮后保存到模板
        if (isSaveBtn === true) {
          const type = this.diagnoseType + '_templates';
          const parentId = data.id.replace(/-\d+$/, "").replace(/^\w+-/, "");
          const findData = this.queryMyTemplateById(parentId);
          if (findData) {
            if (findData[type]) {
              findData[type].unshift(data.name)
            } else {
              findData[type] = [data.name]
            }
          }
        }
        // 上传自定义模板
        try {
          const templateString = JSON.stringify(this.template);
          const response = await this.$apollo.mutate({
            mutation: gql`
            mutation($template: String!) {
              doctorSaveTemplate(template: $template)
            }
          `,
            variables: {
              template: templateString
            }
          });
          if (response.data.doctorSaveTemplate === null) {
            this.$message({
              type: "success",
              message: "上传成功!"
            });
          }
          // tree重新加载
          if (isSaveBtn === true) {
            this.treeReload = !this.treeReload;
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 保存影像诊断
      saveConclusion(bool, ID, showTop1) {
        // 防止blur事件和selectedDisease重复触发本事件函数
        if (this.isTrigger) {
          return
        }
        this.isTrigger = true;
        if (this.diagnoseResult === '') {
          // 恢复状态
          this.isTrigger = false;
          return
        }
        setTimeout(async () => {
          if (this.diagnosisId === -1) {
            this.$message.error("请先添加检查部位！");
            // 恢复状态
            this.isTrigger = false;
          } else {
            const type = {
              dermoscopy: 'skinUnderMirror',
              ct: 'ctUnderMirror',
              b_ultrasonic: 'bcUnderMirror',
              pathology: 'blUnderMirror'
            }
            const isHaveReportText = this.diagnoseType && this.$store.state[type[this.diagnoseType]] !== '';
            const knowledgeDic = this.knowledgeDic;
            let id = "";
            // 是否是通过模板添加的
            if (!bool) {
              if (this.diagnoseResult !== "") {
                const findObj = this.queryMyTemplateByName(this.diagnoseResult);
                if (findObj) {
                  id = findObj.id;
                } else {
                  for (let key in knowledgeDic) {
                    if (knowledgeDic[key].name === this.diagnoseResult) {
                      id = key;
                    }
                  }
                  if (id === "" && this.selectedDiagnose === false) {
                    this.$message.error("请填写与模板对应的名称！");
                    // 恢复状态
                    this.isTrigger = false;
                    return;
                  }
                }
              }
            } else {
              id = ID;
            }
            this.diseaseid = id;
            if (showTop1 === "yes" && this.diagnoseType !== "" && !isHaveReportText) {
              console.log('>>>>>>')
              console.log( this.template.top5Knowledge)
              const top5Knowledge = this.template.top5Knowledge[
                this.diagnoseType
                ];
              if (top5Knowledge.length > 0) {
                const filterArr = top5Knowledge.filter(item => {
                  return item.id === id;
                });
                if (filterArr.length > 0) {
                  this.editUnderMirror(filterArr[0].children[0]);
                } else {
                  // 如果有原始模板则添加原始模板
                  let filterObj = {};
                  const f = data => {
                    for (const item of data) {
                      if (item.id === id) {
                        filterObj = item;
                      } else {
                        if (item.children) {
                          f(item.children);
                        }
                      }
                    }
                  };
                  f(this.knowledgeData);
                  // 判断是否有原始模板
                  if (filterObj[this.diagnoseType + "_templates"]) {
                    this.editUnderMirror({
                      name: filterObj[this.diagnoseType + "_templates"][0]
                    });
                  } else {
                    // 没有原始模板的情况
                    this.editUnderMirror({
                      node: true
                    });
                  }
                }
              } else {
                // 如果有原始模板则添加原始模板
                let filterObj = {};
                const f = data => {
                  for (const item of data) {
                    if (item.id === id) {
                      filterObj = item;
                    } else {
                      if (item.children) {
                        f(item.children);
                      }
                    }
                  }
                };
                f(this.knowledgeData);
                // 判断是否有原始模板
                if (filterObj[this.diagnoseType + "_templates"]) {
                  this.editUnderMirror({
                    name: filterObj[this.diagnoseType + "_templates"][0]
                  });
                } else {
                  // 没有原始模板的情况
                  this.editUnderMirror({
                    node: true
                  });
                }
              }
            }
            // 上传修改影像诊断
            try {
              const res = await this.$apollo.mutate({
                mutation: gql`mutation{
              modifyDiagnosis(id:${this.diagnosisId},doctor_conclusion:"${id}")
            }`
              });
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
          }
          this.isTrigger = false;
        }, 300);
      },
      
      clearJXSJ() {
        this.$confirm("是否删除其他类下的镜下所见?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$store.commit("handleUnderMirror", {type: "skin", data: ""});
            this.$store.commit("handleUnderMirror", {
              type: "general",
              data: ""
            });
            this.$store.commit("handleUnderMirror", {type: "ct", data: ""});
            this.$store.commit("handleUnderMirror", {type: "bc", data: ""});
            this.$store.commit("handleUnderMirror", {type: "bl", data: ""});
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      // 双击点击的时候更改镜下所见内容
      editUnderMirror(data) {
        this.currentData = _.cloneDeep(data);
        if (data.node === true || data.second === true) {
          this.currentData.description = "";
        } else {
          this.currentData.description = data.name;
        }
        if (this.isGeneral) {
          this.$store.commit("handleUnderMirror", {
            type: "general",
            data: this.currentData.description
          });
        } else if (this.isCT) {
          this.$store.commit("handleUnderMirror", {
            type: "ct",
            data: this.currentData.description
          });
        } else if (this.isBC) {
          this.$store.commit("handleUnderMirror", {
            type: "bc",
            data: this.currentData.description
          });
        } else if (this.skin) {
          this.$store.commit("handleUnderMirror", {
            type: "skin",
            data: this.currentData.description
          });
        } else {
          this.$store.commit("handleUnderMirror", {
            type: "bl",
            data: this.currentData.description
          });
        }
      },
      // 接受Tree组件传出的自定义模板
      cloneTemplate(data) {
        // 处理放入knowledgeDic中
        this.template = _.cloneDeep(data);
        const knowledgeDic = this.knowledgeDic;
        if (data.second.length > 0) {
          for (let val of data.second) {
            if (val.children && val.children.length > 0) {
              for (let value of val.children) {
                knowledgeDic[value.id] = {
                  name: value.name
                };
              }
            }
          }
        }
        // 生成影像诊断筛选数据
        const allDiseaseArr = [];
        for (let key in knowledgeDic) {
          if (knowledgeDic.hasOwnProperty(key)) {
            allDiseaseArr.push({
              value: knowledgeDic[key].name,
              id: key
            });
          }
        }
        this.allDisease = allDiseaseArr;
      },
      // 取消右击默认事件
      prevent(e) {
        e.preventDefault();
      },
      // 生成检查编号
      async createDiagnoseId(data2) {
        const response = await this.$apollo.query({
          query: gql`{
            patient(id:${this.patient_id}){
              diagnoses{
                id
              }
            }
          }`,
          fetchPolicy: "no-cache"
        });
        if (this.form.id_in_hospital !== "") {
          data2.id_in_hospital =
            this.form.id_in_hospital +
            "-" +
            (response.data.patient.diagnoses.length + 1);
        } else {
          data2.id_in_hospital =
            this.patient_id + "-" + (response.data.patient.diagnoses.length + 1);
        }
        this.diagnose_id_in_hospital = data2.id_in_hospital;
      },
      // 检查患者身份证是否重复
      async patientIdRepeat(value) {
        const res = await this.$apollo.query({
          query: gql`query($keyword: String){
            patients(keyword: $keyword) {
              id
              name
              id_in_hospital
              gender
              birthday
              race
              skin_color
              skin_type
              address
              id_card_number
              native_place
              country
              profession
              email
              phone
            }
          }`,
          variables: {
            keyword: value,
          },
          fetchPolicy: "no-cache"
        });
        const arr = res.data.patients;
        const filterArr = arr.filter(item => {
          return item.id_in_hospital === value;
        });
        let obj = {};
        if (filterArr.length >= 1) {
          obj = filterArr[0];
        }
        return obj;
      },
      // id可选项
      async querySearchId(queryString, callback) {
        if (queryString !== "") {
          const res = await this.$apollo.query({
            query: gql`query($keyword: String){
                      patients(keyword: $keyword) {
                        id
                        name
                        id_in_hospital
                        gender
                        birthday
                        race
                        skin_color
                        skin_type
                        address
                        id_card_number
                        native_place
                        country
                        profession
                        email
                        phone
                        age
                        created_time
                      }
                  }`,
            fetchPolicy: "no-cache",
            variables: {
              keyword: queryString,
            },
          });
          const arr = res.data.patients;
          const newArr = [];
          for (let i of arr) {
            newArr.push({
              value: `${i.id_in_hospital}`,
              form: {
                id: i.id,
                // 患者id
                id_in_hospital: i.id_in_hospital,
                // 姓名
                name: i.name,
                birthday: i.birthday === this.initialTime ? '' : moment(i.birthday).format('YYYY-MM-DD'),
                age: i.age > -1 ? (i.age + '') : '',
                skin_color: i.skin_color,
                skin_type: i.skin_type,
                gender: i.gender,
                phone: i.phone,
                // 民族
                race: i.race,
                // 地址
                address: i.address,
                // 身份证号
                idCardNumber: i.id_card_number,
                // 籍贯
                nativePlace: i.native_place,
                country: i.country,
                // 职业
                profession: i.profession,
                email: i.email,
                created_time: i.created_time,
              },
              id: i.id
            });
          }
          callback(newArr);
        }
      },
      // 选择了id
      handleSelectId(item) {
        this.useID = true;
        this.isReset = true;
        this.readonly = true;
        this.fromNewDiagnose = true;
        this.form = item.form;
        this.patient_id = item.id;
        // 将最近一次填写检查信息填写上
        this.handleExamineInfo();
        // 请求历史诊断列表
        this.getHistoryCheckData();
        // 重置form表单验证状态
        this.$refs.form.resetFields();
        this.$message({
          type: "success",
          message: "患者已登记，请继续填写病历信息",
        });
      },
      // 保存建议
      async saveSuggestion(value) {
        const id = this.diagnosisId;
        if (id === -1) {
          this.$message.error("请先添加检查部位！");
          return;
        }
        if (value !== "") {
          try {
            await this.$apollo.mutate({
              mutation: gql`mutation($id: Int!, $doctor_suggestion: String){
                modifyDiagnosis(id: $id, doctor_suggestion: $doctor_suggestion)
              }`,
              variables: {
                id,
                doctor_suggestion: value,
              }
            });
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      async checkDiagnosis() {
        const form2Data = _.cloneDeep(this.form2);
        if (
          form2Data.position_overview_list !== "" &&
          form2Data.position_detail_list !== ""
        ) {
          if (!!this.diagnosisId && this.diagnosisId !== -1) {
            // 修改诊断信息
            form2Data.id_in_hospital = this.diagnose_id_in_hospital;
            await this.modifyDiagnosis(form2Data);
          } else {
            await this.createDiagnoseId(form2Data);
            this.form2.id_in_hospital = form2Data.id_in_hospital;
            let addRes = await this.postAddDiagnosis(form2Data);
            this.diagnosisId = addRes.data.addDiagnosis;
            this.$message({
              type: "success",
              message: "添加诊断信息成功"
            });
            this.hospital_id_disabled = true;
            let taggedRes = await this.$apollo.query({
              query: gql`
              query($id: Int!) {
                diagnosis(id: $id) {
                  id
                  tagged
                }
              }
            `,
              variables: {
                id: this.diagnosisId
              }
            });
            this.isCollection = taggedRes.data.diagnosis.tagged;
          }
        }
      },
      // 递归将病名前面的数字去掉
      dealDiseaseName(obj) {
        if (obj.hasOwnProperty("children")) {
          let c = obj.children;
          for (let i = 0; i < c.length; i++) {
            c[i].name = c[i].name.replace(/^[0-9]+-/, "");
            this.dealDiseaseName(c[i]);
          }
        } else {
          obj.name = obj.name.replace(/^[0-9]+-/, "");
          if (obj.name !== "其他") {
            let j = {};
            j.value = obj.name;
            j.id = obj.id;
            this.allDisease.push(j);
          }
        }
      },
      // 打印组件发送来的信息
      printMessage(data) {
        let self = this;
        if (data.type === "back") {
          this.showPort = false;
          this.showSepPort = false;
        } else {
          this.showPort = false;
          this.showSepPort = true;
        }
      },
      // 新建患者
      newPatient() {
        this.newDiagnose();
        this.isNewDiagnose = true;
        this.$store.state.chooseItImgArr = [];
        this.$emit("message", {type: "newPatient"});
        this.useID = false;
        this.hospital_id_disabled = false;
        this.patient_id_disabled = false;
        this.found = false;
      },
      // 接受诊断记录子组件传递过来的值
      messagediagnoserecord(data) {
        switch (data.type) {
          case "close":
            this.showDiagnoseRecord = false;
            break;
          case "showIntell":
            this.detail_result = data.detail_result;
            this.imgList3 = data.imgList;
            this.resiltsVisible = true;
            break;
          case "large":
            this.showLargeImage = true;
            this.largeImage = data.src;
            break;
          case "printreport":
            this.showSepPort = true;
            this.printreport_data = this.form;
            this.printreport_data2 = data.dinfo;
            this.printreport_images = data.data;
            this.printreport_isHostory = false;
            this.printreport_isDownLoad = data.isDownLoad;
            this.printreport_advise = data.advise;
            this.PrintSubmit();
            
            break;
        }
      },
      // 选择表格的某一行
      chooseTableItem(row, column, event) {
        this.choosedTableId = row.id;
        // 显示诊断记录弹窗
        this.showDiagnoseRecord = true;
      },
      filterNode(value, data) {
        if (!value) {
          return true;
        }
        return data.name.indexOf(value) !== -1;
      },
      // 点击百科
      async getContent(data) {
        this.currentData = data;
        let id = "";
        if (this.showInfo) {
          this.showInfo = false;
        }
        if (this.currentData.images) {
          for (let i = 0; i < this.currentData.images.length; i++) {
            this.imgList2[i] =
              api.knowledgeUrl + "/" + this.currentData.images[i];
          }
        } else {
          this.imgList2 = [];
        }
        // 如果是病名节点
        if (data.node === true) {
          this.diagnoseResult = this.currentData.name;
          this.editUnderMirror(data);
          id = data.id;
          // 病的id
          this.diseaseId = this.currentData.id;
        }
        // 如果是点击了亚型病种
        if (data.second === true) {
          this.diagnoseResult = data.name;
          this.editUnderMirror(data);
          id = data.id;
          // 病的id
          this.diseaseId = this.currentData.id;
        }
        // 如果是模板节点
        if (data.dis === true) {
          if (data.predefine === true) {
            // 如果是原始模板下的模板节点
            this.diagnoseResult = this.knowledgeDic[data.id].name;
            this.editUnderMirror(data);
            id = data.id;
          } else {
            // 如果是自定义下的模板节点
            // 上一级节点id
            const parentId = data.id.replace(/-\d+$/, "").replace(/^\w+-/, "");
            // 根据模板id获取病名
            this.diagnoseResult = this.queryMyTemplateById(parentId).name;
            this.editUnderMirror(data);
            id = parentId;
          }
        }
        if (!this.currentData.children) {
          this.showInfo = true;
          this.showInfoDate = this.currentData;
        }
        // 上传保存影像诊断
        this.saveConclusion(true, id, "no");
        this.saveTop5({data, isSaveBtn: false});
      },
      // 取消删除该部位
      cancelDeletePosition() {
        this.deletePositionDialog = false;
      },
      // 确定删除该部位
      confirmDeletePosition() {
        this.choosedPosition.splice(this.deletePositionIndex, 1);
        if (this.deletePositionIndex < this.choosedPositionIndex) {
          this.choosedPositionIndex -= 1;
        } else if (this.deletePositionIndex === this.choosedPositionIndex) {
          this.choosedPositionIndex = this.choosedPosition.length - 1;
          if (this.choosedPosition[this.choosedPositionIndex]) {
            this.choosedPosition[this.choosedPositionIndex].active = true;
          }
        }
        // 删除提交的表单中的相关参数
        const positionOverview = this.form2.position_overview_list.split(',');
        const index1 = positionOverview.findIndex(item => item === this.willDeletePosition.split('-')[0]);
        positionOverview.splice(index1, 1);
        this.form2.position_overview_list = positionOverview.join(',');
        const positionDetail = this.form2.position_detail_list.split(',');
        const index2 = positionDetail.findIndex(item => item === this.willDeletePosition);
        positionDetail.splice(index2, 1);
        this.form2.position_detail_list = positionDetail.join(',');
        this.checkDiagnosis();
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.deletePositionDialog = false;
      },
      // 显示检查部位一级菜单
      showCheckPosition() {
        this.checkoverview = true;
      },
      hideCheckPosition() {
        this.checkoverview = false;
      },
      // 激活一级菜单的选项
      activeTopLevel(index) {
        this.topLevelIndex = index;
      },
      // 激活二级菜单的选项
      activeSecondLevel(event, index) {
        // 防止该事件冒泡
        event.cancelBubble = true;
        this.secondLevelIndex = index;
      },
      // 移动到已经选择的部位位置触发的事件
      moveOnChoosedPosition(index) {
        this.choosedPositionIndex = index;
        for (let i = 0; i < this.choosedPosition.length; i++) {
          if (i === index) {
            this.choosedPosition[i].active = true;
          } else {
            if (this.choosedPosition[i].active) {
              this.choosedPosition[i].active = false;
            }
          }
        }
      },
      // 删除该部位
      deleteThePosition(event, overviewPosition, detailPosition, index) {
        this.deletePositionIndex = index;
        event.cancelBubble = true;
        this.willDeletePosition = overviewPosition + "-" + detailPosition;
        this.deletePositionDialog = true;
      },
      // 确定选择的
      ensureFigure(overviewPosition, detailPosition) {
        if (this.patient_id === "") {
          this.$message.error("请添加患者信息!!!");
          this.checkoverview = false;
          return;
        }
        this.checkoverview = false;
        let choosedJson = {};
        choosedJson.overviewPosition = overviewPosition;
        choosedJson.detailPosition = detailPosition;
        let exist = false;
        for (let i = 0, len = this.choosedPosition.length; i < len; i++) {
          if (
            this.choosedPosition[i].overviewPosition ===
            choosedJson.overviewPosition &&
            this.choosedPosition[i].detailPosition === choosedJson.detailPosition
          ) {
            this.$message.error("您已经选择该部位");
            exist = true;
          }
          this.choosedPosition[i].active = false;
        }
        if (!exist) {
          choosedJson.active = true;
          this.choosedPosition.push(choosedJson);
          this.overviewList.push(choosedJson.overviewPosition);
          this.detailList.push(
            choosedJson.overviewPosition + "-" + choosedJson.detailPosition
          );
          this.form2.position_overview_list = this.overviewList.toString();
          this.form2.position_detail_list = this.detailList.toString();
          // 如果是最后填的这一项就提交表单
          this.checkDiagnosis();
          this.choosedPositionIndex = this.choosedPosition.length - 1;
        }
        this.choosedPosition = _.uniqBy(this.choosedPosition, "detailPosition");
      },
      // 隐藏检查部位一级菜单
      hideCheckPostion() {
        this.checkoverview = false;
      },
      // 点击黄色按钮添加患者
      pushPatient() {
        // 将当前的患者数据清空
      },
      showPatientMore(params) {
        if (params === "show") {
          this.patientMore = false;
        } else {
          this.patientMore = true;
        }
      },
      showCheckMore(params) {
        if (params === "show") {
          this.checkMore = false;
        } else {
          this.checkMore = true;
        }
      },
      closeCamera() {
        this.isTakePhone = false;
        try {
          if (this.tracks[0]) {
            this.tracks[0].stop();
          }
        } catch (error) {
          console.log(error);
        }
      },
      // 偏振光拍摄
      async pz() {
        await this.takePhotos(Util.POLARRIZE.code);
      },
      async takePhotos(type) {
        if (this.diagnosisId === -1) {
          this.$message.error("请先添加检查部位！");
          return;
        }
        let ctx = this.canvas.getContext("2d");
        ctx.drawImage(this.video, 0, 0, 400, 300);
        // canvas图像转为图片
        let image = new Image();
        image.src = this.canvas.toDataURL("image/png",1.0);
        let base64ImgData = image.src.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );
        let imgObjArr = [];
        let imgJson = {};
        imgJson.type = type;
        imgJson.base64 = base64ImgData;
        imgJson.ext = "jpg";
        if (!!this.activePosition) {
          imgJson.position_overview = this.activePosition.overviewPosition;
          imgJson.position_detail =
            this.activePosition.overviewPosition +
            "-" +
            this.activePosition.detailPosition;
        } else {
          this.$message.error("请先添加检查部位");
        }
        if (
          imgJson.position_overview === undefined ||
          imgJson.position_detail === undefined
        ) {
          this.$message.error("请先添加检查部位");
          return;
        }
        imgObjArr.push(imgJson);
        await this.upload(base64ImgData, imgObjArr);
        if (this.selectCamera) {
          window.localStorage.setItem('selectCamera', this.selectCamera);
        }
      },
      // 浸润光拍摄
      async jr() {
        await this.takePhotos(Util.SOAK.code);
      },
      async upload(base64ImgData, imgObjArr) {
        let params = {
          diagnosis_id: this.diagnosisId,
          images: imgObjArr
        };
        if (!!params.diagnosis_id && !!params.images) {
          try {
            let uploadImgsResponse = await this.$apollo.mutate({
              // Query
              mutation: gql`
              mutation($diagnosis_id: Int!, $images: [ImageInput!]!) {
                addImages(diagnosis_id: $diagnosis_id, images: $images)
              }
            `,
              variables: {
                diagnosis_id: params.diagnosis_id,
                images: params.images,
              }
            });
            this.$message({
              message: "上传图片成功",
              type: "success"
            });
          } catch (e) {
            this.$message("上传失败");
          }
        } else {
          this.$message.error("参数错误!");
        }
      },
      // 比较两张图的细节
      compare(data) {
        data.choosedImg = data.choosedImg.replace("thumbnails/", "");
        this.compareImgObj.choosedImg = data.choosedImg;
        this.compareImgObj.compareImg = data.compareImg;
        this.compareImgObj.similarity = data.similarity;
        this.compareImgObj.disease = data.disease;
        this.compareImgObj.isWidth1 = data.isWidth1;
        this.compareImgObj.isWidth2 = data.isWidth2;
        // this.resiltsVisible = false;
        this.compareDialog = true;
      },
      ...mapMutations(["add"]),
      chooseExistPatient() {
        // console.log("in chooseExistPatient form is ",this.form);
      },
      // 请求历史检查记录
      async getHistoryCheckData() {
        let historyRes = await this.$apollo.query({
          query: gql`
          query patient($id: Int!) {
            patient(id: $id) {
              id
              diagnoses {
                id
                applicant
                position_overview_list
                position_detail_list
                doctor_conclusion
                time
                id_in_hospital
                ct_report_images
                images {
                  id
                  type
                }
              }
              hospitalization{
                id
              }
              operation{
                id
              }
            }
          }
        `,
          variables: {
            id: this.patient_id
          },
          fetchPolicy: "no-cache"
        });
        // console.log(historyRes.data);
        if (this.wordbook === null) {
          let res1 = await axios.request({
            method: "get",
            url: api.wordbook,
            headers: {
              "x-csrf-token": csrftoken
            },
            withCredentials: true
          });
          this.wordbook = res1.data;
        }
        this.diagnosesRecordList = historyRes.data.patient.diagnoses;
        const tableData1 = historyRes.data.patient.diagnoses.slice(0, 5);
        for (let i = 0; i < tableData1.length; i++) {
          tableData1[i].diagnosisType = 'image';
          tableData1[i].time = moment(tableData1[i].time).format(
            "YYYY-MM-DD HH:mm"
          );
          tableData1[i].doctor_conclusion = this.filterConclusion(tableData1[i].doctor_conclusion);
          let imgs = tableData1[i].images;
          let typeArr = [];
          for (let j = 0; j < imgs.length; j++) {
            let typeString = "";
            switch (imgs[j].type) {
              case Util.SOAK.code:
                typeString = "皮肤镜";
                break;
              case Util.POLARRIZE.code:
                typeString = "皮肤镜";
                break;
              case Util.GENERAL.code:
                typeString = "大体图/伍德灯";
                break;
              case Util.CT.code:
                typeString = "CT";
                break;
              case Util.BC.code:
                typeString = "B超";
                break;
              case Util.PATHOlOGY.code:
                typeString = "病理";
                break;
            }
            typeArr.push(typeString);
          }
          typeArr = _.uniq(typeArr);
          tableData1[i].typeArr = typeArr.toString();
          if (
            tableData1[i].doctor_conclusion !== "" &&
            this.wordbook !== null
          ) {
            if (!!this.wordbook[tableData1[i].doctor_conclusion]) {
              tableData1[i].doctor_conclusion = this.wordbook[
                tableData1[i].doctor_conclusion
                ].name;
            }
          }
        }
        this.tableData = tableData1;
      },
      dealHistoryData(sourceData) {
        if (!!sourceData) {
          let dataLen = sourceData.length;
          for (let i = 0; i < sourceData.length; i++) {
            let tableItem = {};
            tableItem.index = sourceData[i].id;
            tableItem.historyIndex = sourceData[i].id;
            tableItem.historyDate =
              typeof sourceData[i] === "string"
                ? sourceData[i].time.slice(0, 10)
                : "";
            let positionNumber = Number(
              sourceData[i].position_overview + "" + sourceData[i].position_detail
            );
            tableItem.checkPosition = this.getDetailString(positionNumber);
            tableItem.checkResult = !!sourceData[i].doctor_conclusion
              ? sourceData[i].doctor_conclusion
              : "暂无结果";
            this.tableData.push(tableItem);
          }
        } else {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 取出具体的数字代表的大体部位
      getDetailString(detailNumber) {
        let dataArr = raceJson.options2;
        for (let i = 0, len = dataArr.length; i < len; i++) {
          for (let j = 0, leng = dataArr[i].length; j < leng; j++) {
            if (dataArr[i][j].value === detailNumber) {
              return dataArr[i][j].label;
            }
          }
        }
        return "";
      },
      // 获取摄像头组件传递进来的数据
      getCameraParams(message) {
        switch (message.type) {
          case "closeCamera":
            this.isTakePhone = false;
            break;
        }
      },
      // 接收来自子组件传来的值
      async getCollectionMessage(message) {
        switch (message.type) {
          // 智能搜图
          case "intelligentSearch":
            this.diagnoseResult = "";
            await this.intelligentSubmit();
            
            break;
          // 编辑图片
          case "detailResult":
            if (this.detail_result.length === 0) {
              this.$message.error(this.differentContent.errorCon);
              return;
            } else {
              this.resiltsVisible = true;
            }
            break;
          case "imgEditor":
            this.dialogVisible = true;
            let newData = {};
            newData.position_detail = message.position;
            newData.type = message.idType;
            newData.id = message.id;
            this.LookBigPhoto(message.imgSrc.replace(api.imageSrcPrefixThumbnails, ""), newData, this.form.id)
            this.currentImg = message.imgSrc;
            this.editImgId = message.id;
            this.currentType = message.idType;
            this.currentEditorIndex = message.index;
            // let dragTag = this.$refs.dragEditor;
            break;
          // 删除图片
          case "deleteImg":
            this.centerDialogVisible = true;
            this.deleteImgId = message.id;
            break;
          case "takePhone":
            this.picType = message.picType;
            await this.getCameraList();
            await this.showCamera();
            this.isTakePhone = true;
            this.$nextTick(() => {
              this.$refs.cameraCon.focus();
            });
            break;
          case "importReport":
            if (this.detail_result.length === 0) {
              this.$message.error(this.differentContent.errorCon);
              return;
            } else {
              let disease = message.data;
              this.diagnoseResult = disease.name;
              switch (message.mode) {
                case "sk":
                  this.skinReportObj.underMirror = message.data.description;
                  this.skinReportObj.name = message.data.name;
                  this.skinReportObj.reportImgs = message.reportImgs;
                  this.skinReportObj.position = message.position;
                  this.skinReportObj.mode = "皮肤镜";
                  // 发送给服务器数据信息
                  let importReportRes1 = await this.$apollo.mutate({
                    mutation: gql`mutation ($id: Int!){
                    modifyDiagnosis(id: $id,doctor_conclusion: "${
                      disease.code
                      }",doctor_suggestion: "${ad}",
                    dermoscopy_report_images: "${
                      disease.reportImgs
                      }",dermoscopy_report_text: "${disease.description}")
                  }`,
                    variables: {
                      id: this.diagnosisId
                    }
                  });
                  break;
              }
            }
            
            break;
        }
      },
      async intelligentSubmit() {
        let img = [];
        let choosedImg = _.cloneDeep(this.$store.state.chooseItImgArr);
        if (this.patient_id === "") {
          this.$message.error("请添加患者信息!!!");
          return;
        }
        if (this.diagnosisId === -1) {
          this.$message.error("请添加检查部位!!!");
          return;
        }
        if (choosedImg.length === 0) {
          this.$message.error("请最少选择一张图片");
          return;
        }
        if (choosedImg.length > 3) {
          this.$message.error("最多选择三张搜图图片!!!");
          return;
        }
        
        this.imgList3 = []; // 先清除详情结果图片数据
        for (let i = 0; i < choosedImg.length; i++) {
          img.push(choosedImg[i].id);
          this.imgList3.push(choosedImg[i].src);
        }
        let diagnosisId = this.diagnosisId;
        // 新的智能搜图请求方式
        try {
          await this.$apollo.mutate({
            mutation: gql`
            mutation(
              $diagnosis_id: Int!
              $image_ids: [Int!]!
              $asynchronous: Boolean
            ) {
              aiDiagnose(
                diagnosis_id: $diagnosis_id
                image_ids: $image_ids
                asynchronous: $asynchronous
              )
            }
          `,
            variables: {
              diagnosis_id: diagnosisId,
              image_ids: img,
              asynchronous: true
            },
            fetchPolicy: "no-cache"
          });
          this.disableIntell = true;
          this.loading = true;
          setTimeout(() => {
            if (this.loading && this.disableIntell) {
              this.loading = false;
              // 解禁按钮
              this.disableIntell = false;
              this.$message({
                message: "超时！请重试",
                type: "error"
              });
            }
          }, 12000);
        } catch (error) {
          this.loading = false;
          this.disableIntell = false;
          this.$message({
            message: "超时！请重试",
            type: "error"
          });
        }
      },
      // 激活tag
      activeOption(param, index) {
        switch (index) {
          case 1:
            this.isGeneral = false;
            this.isCT = false;
            this.isBC = false;
            this.skin = true;
            this.bl = false;
            break;
          case 0:
            this.skin = false;
            this.isCT = false;
            this.isBC = false;
            this.isGeneral = true;
            this.bl = false;
            break;
          case 2:
            this.skin = false;
            this.isGeneral = false;
            this.isBC = false;
            this.isCT = true;
            this.bl = false;
            break;
          case 3:
            this.isGeneral = false;
            this.isBC = true;
            this.isCT = false;
            this.skin = false;
            this.bl = false;
            break;
          case 4:
            this.isGeneral = false;
            this.isBC = false;
            this.skin = false;
            this.isCT = false;
            this.bl = true;
            break;
        }
        // 清空已经选择的图片
        // this.$store.state.chooseItImgArr = [];
        for (let i = 0, len = this.tags.length; i < len; i++) {
          if (this.tags[i].text === param && i === index) {
            this.$set(this.tags[i], "checked", true);
          } else {
            if (this.tags[i].checked) {
              // this.tags[i].checked = false;
              this.$set(this.tags[i], "checked", false);
            }
          }
        }
        // 给tree组件传参
        if (this.isCT) {
          this.diagnoseType = "ct";
        }
        if (this.isBC) {
          this.diagnoseType = "b_ultrasonic";
        }
        if (this.skin) {
          this.diagnoseType = "dermoscopy";
        }
        if (this.bl) {
          this.diagnoseType = "pathology";
        }
        if (this.isGeneral) {
          this.diagnoseType = "";
        }
      },
      // 标记
      async mark() {
        let self = this;
        try {
          if (this.diagnosisId === -1) {
            this.$message.error("请先添加患者和添加检查部位！");
            return;
          }
          let collectionRes = await this.$apollo.mutate({
            mutation: gql`
            mutation($id: Int!, $tagged: Boolean) {
              modifyDiagnosis(id: $id, tagged: $tagged)
            }
          `,
            variables: {
              id: self.diagnosisId,
              tagged: !self.isCollection
            }
          });
          if (!self.isCollection) {
            self.isCollection = true;
            this.$message({
              type: "success",
              message: "收藏成功"
            });
          } else {
            self.isCollection = false;
            this.$message({
              type: "success",
              message: "取消收藏成功"
            });
          }
        } catch (e) {
          this.$message.error("收藏失败");
        }
      },
      // 新的诊断
      async newDiagnose() {
        this.clearPortData();
        this.isNewDiagnose = true;
        this.reloadCollection = false;
        this.$nextTick(() => {
          this.reloadCollection = true;
        });
        this.activeOption("大体图/伍德灯", 0);
        this.$store.state.chooseItImgArr = [];
        // 诊断预览结果置空
        this.overview_result = [];
        // 清空检查信息
        for (let key in this.form2) {
          if (this.form2.hasOwnProperty(key)) {
            this.form2[key] = "";
          }
        }
        this.diagnosisId = -1;
        this.choosedPosition = [];
        this.overviewList = [];
        this.detailList = [];
        this.choosedPositionIndex = 0;
        this.checkMore = true;
        this.imgList = [];
        this.advise = "";
        this.diagnoseResult = "";
        this.otherDescription = "";
        if (this.patient_id) {
          await this.getHistoryCheckData();
        }
        this.isShowStateIcon = false;
        this.hospital_id_disabled = false;
        this.$nextTick(() => {
          this.isShowStateIcon = true;
        });
      },
      async loadImages() {
        let self = this;
        try {
          let imgsRes = await this.$apollo.query({
            query: gql`
            query($id: Int!) {
              diagnosis(id: $id) {
                id
                images {
                  id
                  path
                  server
                  type
                  tagged
                  position_overview
                  position_detail
                }
              }
            }
          `,
            variables: {
              id: self.diagnosisId
            },
            fetchPolicy: "no-cache"
          });
          let images = [];
          let newRes = imgsRes.data.diagnosis.images;
          images = newRes.map(v => {
            const newV = _.cloneDeep(v);
            newV.path = `${api.server}/skin_images/thumbnails/${v.path}`;
            newV.checked = false;
            newV.ext = "png";
            return newV;
          });
          
          
          // let images = imgsRes.data.diagnosis.images.map(v => {
          //   if (v.path) {
          //     v.path = `${api.server}/skin_images/thumbnails/${v.path}`;
          //   }
          //   v.type = v.type;
          //   v.checked = false;
          //   v.ext = "png";
          //   v.tagged = v.tagged;
          //   v.id = v.id;
          //   v.position_overview = v.position_overview;
          //   v.position_detail = v.position_detail;
          //   return v;
          // });
          this.imgList = images;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 请求添加病人
      async addSicker(params) {
        let response = await this.$apollo.mutate({
          // Query
          mutation: gql`mutation(
            $id_in_hospital: String!
            $name: String!
            $gender: String!
            $birthday: String!
            $race: String!
            $skin_color: String!
            $skin_type: String!
            $phone: String!
            $address: String!
            $id_card_number: String!
            $native_place: String!
            $country: String!
            $profession: String!
            $email: String!
            $age: Int
          ){
          addPatient(
             id_in_hospital: $id_in_hospital,
             name: $name,
             gender: $gender,
             birthday: $birthday,
             race: $race,
             skin_color: $skin_color,
             skin_type: $skin_type,
             phone: $phone,
             address: $address,
             id_card_number: $id_card_number,
             native_place: $native_place,
             country: $country,
             profession: $profession,
             email: $email,
             age: $age
             ){
               id
             }
          }`,
          variables: {
            id_in_hospital: params.id_in_hospital,
            name: params.name,
            gender: params.gender,
            birthday: params.birthday ? params.birthday : moment(this.initialTime).format('YYYY-MM-DD'),
            race: params.race,
            skin_color: params.skin_color,
            skin_type: params.skin_type,
            phone: params.phone,
            address: params.address,
            id_card_number: params.idCardNumber,
            native_place: params.nativePlace,
            country: params.country,
            profession: params.profession,
            email: params.email,
            age: params.age ? Number(params.age) : -1,
          },
        });
        return response;
      },
      // 添加患者
      async handleClick(tab, event) {
        let formData = this.form;
        if (
          formData.birthday === "" ||
          formData.gender === "" ||
          formData.id_in_hospital === "" ||
          formData.name === "" ||
          formData.phone === "" ||
          formData.skin_color === ""
        ) {
          this.$message.error("请填写基本信息!!");
        } else {
          let reg = /^1\d{10}/;
          if (!reg.test(formData.phone)) {
            this.$message.error("手机号码不合法请重新填写手机号");
            return;
          }
          let response;
          if (this.patient_id !== "") {
            // 说明已经添加过诊断只需要修改就行了
            await this.modifySicker(formData);
          }
        }
      },
      // 修改患者信息
      async modifySicker(formData) {
        if (
          formData.id_in_hospital !== "" &&
          formData.name !== "" &&
          formData.gender !== "" &&
          (formData.birthday || formData.age !== '')
        ) {
          let res;
          let pid = this.patient_id;
          res = await this.$apollo.mutate({
            mutation: gql`mutation (
              $id: Int!
              $id_in_hospital: String
              $name: String
              $gender: String
              $birthday: String
              $race: String
              $skin_color: String
              $skin_type: String
              $phone: String
              $address: String
              $id_card_number: String
              $native_place: String
              $country: String
              $profession: String
              $email: String
              $age: Int
            ){
              modifyPatient(
                id: $id,
                age: $age,
                id_in_hospital: $id_in_hospital,
                name: $name,
                gender: $gender,
                birthday: $birthday,
                race: $race,
                skin_color: $skin_color,
                skin_type: $skin_type,
                phone: $phone,
                address: $address,
                id_card_number: $id_card_number,
                native_place: $native_place,
                country: $country,
                profession: $profession,
                email: $email
              )
            }`,
            variables: {
              id: pid,
              id_in_hospital: formData.id_in_hospital,
              name: formData.name,
              gender: formData.gender,
              birthday: formData.birthday ? formData.birthday : moment(this.initialTime).format('YYYY-MM-DD'),
              race: formData.race,
              skin_color: formData.skin_color,
              skin_type: formData.skin_type,
              phone: formData.phone,
              address: formData.address,
              id_card_number: formData.idCardNumber,
              native_place: formData.nativePlace,
              country: formData.country,
              profession: formData.profession,
              email: formData.email,
              age: formData.age ? Number(formData.age) : -1,
            },
            fetchPolicy: "no-cache"
          });
        }
      },
      // 添加诊断信息
      async addDiagnosis() {
        const form2Data = _.cloneDeep(this.form2);
        if (
          form2Data.position_overview_list !== "" &&
          form2Data.position_detail_list !== ""
        ) {
          this.cacheInputData("applyDoctors", form2Data);
          this.cacheInputData("applyUnit", form2Data);
          this.cacheInputData("reviewDoctorCache", form2Data);
          this.cacheInputData("checkUnit", form2Data);
          this.cacheInputData("fee", form2Data);
          if (!!this.diagnosisId && this.diagnosisId !== -1) {
            // 修改诊断信息
            form2Data.id_in_hospital = this.diagnose_id_in_hospital;
            await this.modifyDiagnosis(form2Data);
          } else {
            if (this.patient_id === "") {
              this.$message.error("请先填写患者信息!!");
              return;
            }
            await this.createDiagnoseId(form2Data);
            this.form2.id_in_hospital = form2Data.id_in_hospital;
            let addRes = await this.postAddDiagnosis(form2Data);
            this.diagnosisId = addRes.data.addDiagnosis;
            this.$message({
              type: "success",
              message: "添加诊断信息成功"
            });
            this.hospital_id_disabled = true;
            let taggedRes = await this.$apollo.query({
              query: gql`
              query($id: Int!) {
                diagnosis(id: $id) {
                  id
                  tagged
                }
              }
            `,
              variables: {
                id: this.diagnosisId
              }
            });
            this.isCollection = taggedRes.data.diagnosis.tagged;
          }
        }
      },
      // 缓存输入数据
      cacheInputData(type, form2Data) {
        if (!!localStorage.getItem(type)) {
          // 取出数据解析成json数据
          let applyDoctorsStorage = JSON.parse(localStorage.getItem(type));
          let allowPush = true;
          let allowPushU = true;
          let allowPushR = true;
          let allowPushUn = true;
          let allowPushF = true;
          for (let i = 0; i < applyDoctorsStorage.length; i++) {
            switch (type) {
              case "applyDoctors":
                if (
                  applyDoctorsStorage[i].value === form2Data.applicant &&
                  applyDoctorsStorage[i].label === form2Data.applicant
                ) {
                  allowPush = false;
                }
                break;
              case "applyUnit":
                if (
                  applyDoctorsStorage[i].value === form2Data.applicant_unit &&
                  applyDoctorsStorage[i].label === form2Data.applicant_unit
                ) {
                  allowPushU = false;
                }
                break;
              case "reviewDoctorCache":
                if (
                  applyDoctorsStorage[i].value === form2Data.review_doctor &&
                  applyDoctorsStorage[i].label === form2Data.review_doctor
                ) {
                  allowPushR = false;
                }
                break;
              case "checkUnit":
                if (
                  applyDoctorsStorage[i].value === form2Data.unit &&
                  applyDoctorsStorage[i].label === form2Data.unit
                ) {
                  allowPushUn = false;
                }
                break;
              case "fee":
                if (
                  applyDoctorsStorage[i].value === form2Data.fee &&
                  applyDoctorsStorage[i].label === form2Data.fee
                ) {
                  allowPushF = false;
                }
                break;
            }
          }
          let dataJson = {};
          switch (type) {
            case "applyDoctors":
              if (form2Data.applicant !== "") {
                dataJson.value = form2Data.applicant;
                dataJson.label = form2Data.applicant;
                this.applyDoctors = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPush &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "applyUnit":
              if (form2Data.applicant_unit !== "") {
                dataJson.value = form2Data.applicant_unit;
                dataJson.label = form2Data.applicant_unit;
                this.applyUnit = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushU &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "reviewDoctorCache":
              if (form2Data.review_doctor !== "") {
                dataJson.value = form2Data.review_doctor;
                dataJson.label = form2Data.review_doctor;
                this.review_doctor_cache = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushR &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "checkUnit":
              if (form2Data.unit !== "") {
                dataJson.value = form2Data.unit;
                dataJson.label = form2Data.unit;
                this.check_unit = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushUn &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
            case "fee":
              if (form2Data.fee !== "0.00") {
                dataJson.value = form2Data.fee;
                dataJson.label = form2Data.fee;
                this.feeList = applyDoctorsStorage;
                if (
                  !!applyDoctorsStorage &&
                  allowPushF &&
                  applyDoctorsStorage.length < 6
                ) {
                  applyDoctorsStorage.push(dataJson);
                  // 将新的数组存进本地
                  localStorage.setItem(type, JSON.stringify(applyDoctorsStorage));
                }
              }
              break;
          }
        } else {
          let arr = [];
          let dataJson = {};
          switch (type) {
            case "applyDoctors":
              if (form2Data.applicant !== "") {
                dataJson.value = form2Data.applicant;
                dataJson.label = form2Data.applicant;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "applyUnit":
              if (form2Data.applicant_unit !== "") {
                dataJson.value = form2Data.applicant_unit;
                dataJson.label = form2Data.applicant_unit;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "reviewDoctorCache":
              if (form2Data.review_doctor !== "") {
                dataJson.value = form2Data.review_doctor;
                dataJson.label = form2Data.review_doctor;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "checkUnit":
              if (form2Data.unit !== "") {
                dataJson.value = form2Data.unit;
                dataJson.label = form2Data.unit;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
            case "fee":
              if (form2Data.fee !== "0.00") {
                dataJson.value = form2Data.fee;
                dataJson.label = form2Data.fee;
                arr.push(dataJson);
                localStorage.setItem(type, JSON.stringify(arr));
              }
              break;
          }
        }
      },
      // 提交诊断信息数据
      async postAddDiagnosis(data) {
        // 防止重复提交
        if (this.diagnosisId === -1) {
          if (typeof data.fee !== "number") {
            data.fee = Number(data.fee);
          }
          if (this.patient_id === "") {
            this.$message.error("请先添加患者!!!");
            return;
          }
          let patientId = this.patient_id;
          try {
            let response = await this.$apollo.mutate({
              // Query
              mutation: gql`mutation(
                $patient_id: Int!,
                $applicant: String,
                $applicant_unit: String,
                $fee: Int,
                $review_doctor: String,
                $unit: String,
                $initial_conclusion: String,
                $lab: String,
                $id_in_hospital: String,
                $position_overview_list: String!,
                $position_detail_list: String!,
                $complaint: String,
                $disease_history_present: String,
                $disease_history_family: String,
                $disease_history_before: String,
              ){
                addDiagnosis(
                  patient_id: $patient_id,
                  applicant: $applicant,
                  applicant_unit: $applicant_unit,
                  fee: $fee,
                  review_doctor: $review_doctor,
                  unit: $unit,
                  initial_conclusion: $initial_conclusion,
                  lab: $lab,
                  id_in_hospital: $id_in_hospital,
                  position_overview_list: $position_overview_list,
                  position_detail_list: $position_detail_list,
                  complaint: $complaint,
                  disease_history_present: $disease_history_present,
                  disease_history_family: $disease_history_family,
                  disease_history_before: $disease_history_before,
                )
              }`,
              variables: {
                fee: Math.floor(data.fee * 100),
                patient_id: patientId,
                applicant: data.applicant,
                applicant_unit: data.applicant_unit,
                review_doctor: data.review_doctor,
                unit: data.unit,
                initial_conclusion: data.initial_conclusion,
                id_in_hospital: data.id_in_hospital,
                position_overview_list: data.position_overview_list,
                position_detail_list: data.position_detail_list,
                complaint: data.complaint,
                disease_history_present: data.disease_history_present,
                disease_history_family: data.disease_history_family,
                disease_history_before: data.disease_history_before,
              }
            });
            this.$message({
              type: "success",
              message: "添加诊断信息成功"
            });
            this.hospital_id_disabled = true;
            return response;
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
            return null;
          }
        }
      },
      // 修改诊断信息
      async modifyDiagnosis(data) {
        let copyData = _.cloneDeep(data);
        try {
          let diagnose_id = this.diagnosisId;
          if (typeof copyData.fee !== "number") {
            copyData.fee = Number(copyData.fee);
          }
          let response = await this.$apollo.mutate({
            // Query
            mutation: gql`mutation (
              $id: Int!,
              $fee: Int,
              $applicant: String,
              $applicant_unit: String,
              $review_doctor: String,
              $unit: String,
              $initial_conclusion: String,
              $id_in_hospital: String,
              $position_overview_list: String,
              $position_detail_list: String,
              $lab: String,
              $complaint: String,
              $disease_history_present: String,
              $disease_history_family: String,
              $disease_history_before: String,
            ){
              modifyDiagnosis(
                id: $id,
                fee: $fee,
                applicant: $applicant,
                applicant_unit: $applicant_unit,
                review_doctor: $review_doctor,
                unit: $unit,
                initial_conclusion: $initial_conclusion,
                id_in_hospital: $id_in_hospital,
                position_overview_list: $position_overview_list,
                position_detail_list: $position_detail_list,
                lab: $lab,
                complaint: $complaint,
                disease_history_present: $disease_history_present,
                disease_history_family: $disease_history_family,
                disease_history_before: $disease_history_before,
              )
            }`,
            variables: {
              id: diagnose_id,
              fee: Math.floor(copyData.fee * 100),
              applicant: data.applicant,
              applicant_unit: data.applicant_unit,
              review_doctor: data.review_doctor,
              unit: data.unit,
              initial_conclusion: data.initial_conclusion,
              id_in_hospital: data.id_in_hospital,
              position_overview_list: data.position_overview_list,
              position_detail_list: data.position_detail_list,
              lab: data.lab,
              complaint: data.complaint,
              disease_history_present: data.disease_history_present,
              disease_history_family: data.disease_history_family,
              disease_history_before: data.disease_history_before,
            }
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 拍摄相片
      photograph() {
        if (this.$refs.myVideo.srcObject !== null) {
          this.$refs.myCanvas
            .getContext("2d")
            .drawImage(this.$refs.myVideo, 0, 0, 600, 450);
          this.imgList.push({
            base64: this.$refs.myCanvas.toDataURL("image/jpg",1.0),
            checked: false,
            ext: "jpg"
          });
        }
      },
      showEdit(index) {
        this.currentIndex = index;
      },
      hidEdit() {
        this.currentIndex = -1;
        this.currentIndex2 = -1;
      },
      hidEdit2() {
        this.currentIndex2 = -1;
      },
      editHandler(imgSrc, num, id) {
        this.currentImg = imgSrc;
        this.currentType = num;
        this.editImgId = id;
        this.dialogVisible = true;
      },
      setImg() {
        this.$refs.mychild.getImgSrc(this.currentImg);
      },
      closeEdit() {
        this.dialogVisible = false;
      },
      async getImgSrc(data) {
        let base64 = data.imgData.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );
        try {
          let deleteRes = await this.$apollo.mutate({
            mutation: gql`
            mutation($id: Int!, $tagged: Int!, $base64: String!) {
              modifyImage(id: $id, tagged: $tagged, base64: $base64)
            }
          `,
            variables: {
              id: this.editImgId,
              tagged: this.currentImg.tagged ? 1 : 0,
              base64
            }
          });
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.$store.commit("setEditImgSrc", data.currentImg.path);
        } catch (e) {
          this.$message.error("上传失败");
        }
        this.dialogVisible = false;
      },
      closeResult() {
        this.resiltsVisible = false;
      },
      async showPrint(isDownLoad) {
        try {
          
          let self = this;
          this.newDownLoad = isDownLoad;
          // 给服务器发送报告及镜下所见和图片索引
          if (this.patient_id === "") {
            this.$message.error("请添加患者信息!!!");
            return;
          }
          if (this.diagnosisId === -1) {
            this.$message.error("没有添加检查部位，无法生成报告");
            return;
          }
          let timeRes = await this.$apollo.query({
            query: gql`
          query($id: Int!) {
            diagnosis(id: $id) {
              id
              time
              doctor_conclusion
            }
          }
        `,
            variables: {
              id: this.diagnosisId
            }
          });
          let conclusion = timeRes.data.diagnosis.doctor_conclusion;
          let time = moment(timeRes.data.diagnosis.time).format("YYYY-MM-DD HH:mm");
          this.reportObj.skin = {};
          this.reportObj.skin.imgs = this.$store.state.skinReportImgs;
          let skinIds = this.installImgsId(this.reportObj.skin.imgs).toString();
          this.reportObj.skin.underMirror = this.$store.state.skinUnderMirror;
          this.reportObj.general = {};
          this.reportObj.general.imgs = this.$store.state.generalReportImgs;
          let generalIds = this.installImgsId(
            this.reportObj.general.imgs
          ).toString();
          this.reportObj.general.underMirror = this.$store.state.generalUnderMirror;
          this.reportObj.ct = {};
          this.reportObj.ct.imgs = this.$store.state.ctReportImgs;
          let ctIds = this.installImgsId(this.reportObj.ct.imgs).toString();
          this.reportObj.ct.underMirror = this.$store.state.ctUnderMirror;
          this.reportObj.bc = {};
          this.reportObj.bc.imgs = this.$store.state.bcReportImgs;
          let bcIds = this.installImgsId(this.reportObj.bc.imgs).toString();
          this.reportObj.bc.underMirror = this.$store.state.bcUnderMirror;
          this.reportObj.bl = {};
          this.reportObj.bl.imgs = this.$store.state.blReportImgs;
          let blIds = this.installImgsId(this.reportObj.bl.imgs).toString();
          this.reportObj.bl.underMirror = this.$store.state.blUnderMirror;
          let diseaseR;
          if (this.allDisease) {
            diseaseR = this.allDisease.filter(ele => {
              if (ele.value === self.diagnoseResult) {
                return ele;
              } else {
                return "";
              }
            });
          } else {
            diseaseR = [];
          }
          this.reportObj.diagnoseResult = self.diagnoseResult;
          this.reportObj.time = time;
          let otherDescription = this.otherDescription;
          this.reportObj.otherDes = otherDescription;
          let reportobject = this.reportObj;
          let bingId = "";
          if (!!diseaseR && diseaseR.length > 0) {
            bingId = diseaseR[0].id;
          } else {
            bingId = "";
          }
          // 修改诊断信息
          let modifyRes = await this.$apollo.mutate({
            mutation: gql`mutation (
            $id: Int!,
            $dermoscopy_report_images: String,
            $dermoscopy_report_text: String,
            $macro_report_images: String,
            $macro_report_text: String,
            $ct_report_images: String,
            $ct_report_text: String,
            $b_ultrasonic_report_images: String,
            $b_ultrasonic_report_text: String,
            $pathology_report_images: String,
            $pathology_report_text: String,
            $doctor_conclusion: String,
            $doctor_report: String
          ){
            modifyDiagnosis(
              id: $id,
              dermoscopy_report_images: $dermoscopy_report_images,
              dermoscopy_report_text: $dermoscopy_report_text,
              macro_report_images: $macro_report_images,
              macro_report_text: $macro_report_text,
              ct_report_images: $ct_report_images,
              ct_report_text: $ct_report_text,
              b_ultrasonic_report_images: $b_ultrasonic_report_images,
              b_ultrasonic_report_text: $b_ultrasonic_report_text,
              pathology_report_images: $pathology_report_images,
              pathology_report_text: $pathology_report_text,
              doctor_conclusion: $doctor_conclusion,
              doctor_report: $doctor_report
            )
          }`,
            variables: {
              id: this.diagnosisId,
              dermoscopy_report_images: skinIds,
              dermoscopy_report_text: reportobject.skin.underMirror,
              macro_report_images: generalIds,
              macro_report_text: reportobject.general.underMirror,
              ct_report_images: ctIds,
              ct_report_text: reportobject.ct.underMirror,
              b_ultrasonic_report_images: bcIds,
              b_ultrasonic_report_text: reportobject.bc.underMirror,
              pathology_report_images: blIds,
              pathology_report_text: reportobject.bl.underMirror,
              // doctor_conclusion: bingId,
              doctor_report: otherDescription,
            }
          });
          // this.showPort = true;
          this.printreport_data = this.form;
          this.printreport_data2 = this.form2;
          this.printreport_images = this.reportObj;
          this.printreport_isHostory = true;
          this.printreport_isDownLoad = isDownLoad;
          this.printreport_advise = this.advise;
          this.PrintSubmit();
        } catch (error) {
          if (error.message.split(":")[1] === ' Failed to fetch') {
            this.$message.error("网络异常，请检查网络!");
          } else {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      installImgsId(imgs) {
        let ids = [];
        if (!!imgs) {
          for (let i = 0; i < imgs.length; i++) {
            ids.push(imgs[i].id);
          }
        }
        ids = _.uniq(ids);
        return ids;
      },
      deleteImg(index, id) {
        this.deleteImgIndex = index;
        this.deleteImgId = id;
        this.centerDialogVisible = true;
      },
      // 确认删除
      async confirmDeletion() {
        let ids = [];
        ids.push(this.deleteImgId);
        let params = {
          diagnosis_id: this.diagnosisId,
          ids
        };
        try {
          let deleteRes = await this.$apollo.mutate({
            mutation: gql`
            mutation($diagnosis_id: Int!, $ids: [Int!]!) {
              removeImages(diagnosis_id: $diagnosis_id, ids: $ids)
            }
          `,
            variables: {
              diagnosis_id: params.diagnosis_id,
              ids: params.ids
            }
          });
          if (deleteRes.data.removeImages) {
            this.$store.commit("popItImgArr", {
              id: this.deleteImgId
            });
            this.$message({
              type: "success",
              message: "删除图片成功"
            });
          }
          this.centerDialogVisible = false;
          for (let i = 0; i < this.checkedIndex.length; i++) {
            if (this.checkedIndex[i] === this.deleteImgIndex) {
              this.checkedIndex.splice(i, 1);
            }
            if (index < this.checkedIndex[i]) {
              this.checkedIndex.splice(i, 1, this.checkedIndex[i] - 1);
            }
          }
        } catch (e) {
          this.$message.error("删除图片失败！");
        }
      },
      removeImg(index) {
        this.imgList2.splice(index, 1);
        this.report_images.splice(index, 1);
      },
      showRemove(index) {
        this.currentIndex2 = index;
      },
      incorrect() {
        this.isCorrect = true;
      },
      /*queryDisease(queryString, cb) {
        const restaurants = this.allDisease;
        const results = queryString
          ? restaurants.filter(this.filterDisease(queryString))
          : restaurants;
        const arr = [];
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
              if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
                arr.push({
                  id: data[i].id,
                  value: data[i].name,
                })
              }
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (this.template.myTemplate) {
          f(this.template.myTemplate);
        }
        for (const item of results) {
          const findIndex = arr.findIndex(item1 => item.value === item1.value);
          if (findIndex === -1) {
            arr.push(item);
          }
        }
        cb(arr);
      },*/
      /*filterDisease(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
          );
        };
      },*/
      /*selectedDisease(item) {
        this.selectedDiagnose = true;
        this.diagnoseResult = item.value;
        this.saveConclusion(true, item.id, "yes");
      },*/
      // 远程搜索
      async querySearch(queryString, cb) {
        let apolloRes = await this.$apollo.query({
          query: gql`
          query($keyword: String!) {
            patients(keyword: $keyword) {
              id
              name
              gender
              phone
              address
              country
              id_card_number
              native_place
              profession
              email
              birthday
              id_in_hospital
              race
              skin_color
              skin_type
              age
              created_time
            }
          }
        `,
          variables: {
            keyword: queryString
          },
          fetchPolicy: "no-cache"
        });
        let restaurantsResponse = apolloRes.data.patients;
        const restaurants = restaurantsResponse;
        const results = queryString
          ? restaurants.filter(this.filterName(queryString))
          : restaurants;
        cb(results);
      },
      queryApplyDoctors(queryString, cb) {
        const restaurants = this.applyDoctors;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 3);
        cb(results);
      },
      queryApplyUnit(queryString, cb) {
        const restaurants = this.applyUnit;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 3);
        cb(results);
      },
      queryReviewDoctor(queryString, cb) {
        const restaurants = this.review_doctor_cache;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 3);
        cb(results);
      },
      queryCheckUnit(queryString, cb) {
        const restaurants = this.check_unit;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 3);
        cb(results);
      },
      queryFee(queryString, cb) {
        const restaurants = this.feeList;
        let results = queryString
          ? restaurants.filter(this.filterApply(queryString))
          : restaurants;
        results = results.slice(0, 3);
        cb(results);
      },
      filterApply(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
          );
        };
      },
      filterName(queryString) {
        return restaurant => {
          return (
            restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        };
      },
      selectedDoctor(item) {
        // console.log("选择的申请医生是：",item);
      },
      selectedApplyUnit(item) {
        // console.log("选择的申请单位是：",item);
      },
      selectedReviewDoctor(item) {
        // console.log("选择的审核医生是：",item);
      },
      selectedCheckUnit(item) {
        // console.log("选择的检查单位是：",item);
      },
      selectedCheckFee(item) {
        // console.log("选择的检查费用是：",item);
      },
      createFilter(queryString) {
        return restaurant => {
          return (
            restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        };
      },
      // 处理选中状态选中之后的item统一在这里进行复制 queryString 远程查询结果在这里重新复制item form
      handleSelect(item) {
        // 重置form表单验证状态
        this.$refs.form.resetFields();
        
        this.isReset = true;
        this.readonly = true;
        this.fromNewDiagnose = true;
        this.form.name = item.name;
        this.form.created_time = item.created_time;
        this.form.age = item.age > -1 ? (item.age + '') : '';
        this.form.birthday = item.birthday === this.initialTime ? '' : moment(item.birthday).format('YYYY-MM-DD');
        this.form.id = item.id;
        this.form.id_in_hospital = item.id_in_hospital;
        this.form.gender = item.gender;
        this.form.skin_color = item.skin_color;
        this.form.skin_type = item.skin_type;
        this.form.race = item.race;
        this.form.phone = item.phone;
        this.patient_id = item.id;
        this.form.address = item.address;
        this.form.idCardNumber = item.id_card_number;
        this.form.nativePlace = item.native_place;
        this.form.country = item.country;
        this.form.profession = item.profession;
        this.form.email = item.email;
        // 将最近一次填写检查信息填写上
        this.handleExamineInfo()
        // 请求历史诊断列表
        this.getHistoryCheckData();
        this.$message({
          type: "success",
          message: "患者已登记，请继续填写病历信息",
        });
      },
      showBigImg(num) {
        this.showBigList = true;
        this.$refs.mySwiper.swiper.slideTo(num, 1000, false);
      },
      swiperChange() {
        // console.log("swiper change");
      },
      closeBigList(event) {
        this.showBigList = false;
      }
    },
    components: {
    //   DetailedResults,
      // PrintReport,
      swiper,
      swiperSlide,
    //   GeneralPlan,
    //   CollectionType,
    //   DiagnoseRecord,
    //   Tree,
    //   CompareImage
    }
  };
